module.exports = __webpack_public_path__ + "static/img/8.8826628.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/eng/8.png
// module id = DgxN
// module chunks = 0